import { ReactComponent as bus } from './bus.svg'
export default bus
